<template>
  <adv-product-page-button
    class="addtoCart"
    v-on:btn-click="buttonClick"
    :disabled="disabled"
    :productId="productId"
    :quantity="quantity"
    :is-listing="isListing"
    :is-variation-group-master="isVariationGroupMaster"
    :attribute-ids-with-stock="getAttributeIdsWithStock"
    :button-text="buttonText"
    :cart-quantity="cartQuantity"
  >
    <template>
      <div v-if="availabilityInfo && availabilityInfo.availabilityMessage" class="availability-container">
        <div class="availability-wrapper">
          <span class="info-lottie">
            <Lottie
              ref="lottie"
              :animation-data="lottieFile"
              :auto-play="true"
              :loop="true"
              width="26px"
              height="26px"
            />
          </span>
          <span
            class="dioptra-product-availability-text"
            v-html="availabilityInfo.availabilityMessage"
          />
        </div>
      </div>
    </template>
  </adv-product-page-button>
</template>

<script>
import onlineMixin from './mixins/onlineMixin'
import cartButtonMixin from './mixins/cartButtonMixin'
import AdvProductPageButton from './presentation/AdvProductPageButton'
import { flatten } from 'lodash-es'
import { mapGetters } from 'vuex'
import productMixin from './mixins/productMixins'
import Lottie from './Lottie.vue'
import infoLottie from '../lotties/product_page_info_icon.json'

export default {
  name: 'AdvProductPageCartButton',
  components: {
    Lottie,
    AdvProductPageButton
  },
  mixins: [onlineMixin, cartButtonMixin, productMixin],
  props: {
    productId: Number,
    quantity: {
      type: Number,
      default: 0
    },
    stock: {
      type: Number,
      default: 1
    },
    unavailable: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Boolean,
      default: false
    },
    cartLimitReached: {
      type: Boolean,
      default: false
    },
    hasAttributes: {
      type: Boolean,
      default: false
    },
    selectedAttributeId: {
      type: Number,
      default: null
    },
    isListing: {
      type: Boolean,
      default: false
    },
    isVariationGroupMaster: {
      type: Boolean,
      default: false
    },
    productCodeId: {
      type: Number,
      default: null,
      required: false
    },
    cartQuantity: {
      type: Number,
      default: 0
    },
    productMetaData: {
      type: Object,
      default: () => ({})
    },
    availabilityInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      version: '0.0.3'
    }
  },
  computed: {
    ...mapGetters(['getProductById']),
    productData () {
      return this.getProductById(this.productId)
    },
    getAttributeIdsWithStock () {
      return flatten(this.productData.productCodes
        .filter(item => item.productStock > 0)
        .map(item => item.productCodeAttributes))
    },
    lottieFile () {
      return infoLottie
    }
  },
  methods: {
    buttonClick () {
      if ((this.stock <= 0 && !this.isPreorderProduct && (!this.isListing && !this.isVariationGroupMaster)) || this.cartLimitReached) {
        this.$emit('btn-click-no-stock')
      } else if (this.isListing && this.isVariationGroupMaster) {
        this.$emit('btn-click-variation-master')
      } else {
        this.$emit('btn-click')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.availability-container {
  display: grid;
  margin-top: 10px;
  justify-items: center;
  align-items: center;
  justify-content: center;
  align-content: center;
}
.availability-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}
</style>
